$(".tabs__btn").on("click", function () {
  const id = $(this).data("id");
  $(".tabs__btn").removeClass("active");
  $(".tabs__content").removeClass("active");
  $(this).addClass("active");
  $(".tabs__content[data-id='" + id + "']").addClass("active");
});
